import { Box, Heading, Text } from '@chakra-ui/react';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface INoContentAvailableProps {
  query: string;
}
export const NoContentAvailableHubs: FC<INoContentAvailableProps> = ({ query }) => {
  const { t } = useTranslation();

  const messageContent = useMemo(() => {
    if (query) return t(`eventListPage.searchNoResultsHeading`, { query });
    return t('eventListPage.noEventsHubs');
  }, [query]);

  return (
    <Box>
      <Heading fontSize={{ base: '2xl', md: '3xl' }}>{messageContent}</Heading>
      {query && <Text mt={4}>{t(`eventListPage.searchNoResultsDescription`)}</Text>}
    </Box>
  );
};
